import React, { Component } from 'react';
import apiClient from '../lib/apiClient';
class NewSong extends Component {
	constructor() {
		super();
		this.state = {
			id: "",
			artist: "",
			name: "",
		}
	}

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({ [name]: value })
	}

	handleSubmit = async (event) => {
		const { id, artist, name } = this.state;
		event.preventDefault();
		await apiClient.addSong({ id, artist, name });
		location.href = "https://max-and-sax.netlify.app/jukebox";
	}

	render() {
		const { id, artist, name } = this.state;
		return (
			<div className="flex flex-col items-center h-2/3 main justify-evenly">
				<p className="text-2xl">Afegir nova cançó</p>
				<form onSubmit={this.handleSubmit}>
					<label>Número de pàgina: </label>
					<input type="number" name="id" className="mb-5 p-1 block rounded-sm border border-solid border-blue-600" value={id} onChange={this.handleChange}/>
					
					<label>Artista: </label>
					<input type="text" name="artist"  className="mb-5 p-1 block rounded-sm border border-solid border-blue-600" value={artist} onChange={this.handleChange}/>
					
					<label>Nom de la cançó: </label>
					<input type="text" name="name"   className="mb-5 p-1 block rounded-sm border border-solid border-blue-600" value={name} onChange={this.handleChange}/>
					<div>
						<input className="button w-full" type="submit" value="Afegeix nova cançó" />
					</div>
				</form>
			</div>
		);
	}
}

export default NewSong;